import { PermissionName } from 'c-sdk';
import {
    NewCampaignPagePermissions,
    UpdateCampaignLineItemsPagePermissions,
} from 'c-main/Pages/Campaign/pagePermissions';

// Keep this module a leaf: no page or component imports. CampaignOverviewPage and
// CampaignListSearch spread these at module scope, and a page import here closes an import cycle
// that leaves them undefined mid-load (see AGENTS.md).

export const clientReadPerms = [PermissionName.UniledportalClientRead];
export const dateReadPerms = [PermissionName.UniledportalCampaignRead];

export const displaysPerms = [
    PermissionName.UniledportalCampaign_displayRead,
    PermissionName.UniledportalBudget_summary_line_itemRead,
];

export const popImagePerms = [...displaysPerms, PermissionName.UniledportalCampaign_pop_shotsRead];

export const viewToFillPerms = [PermissionName.OthersCampaign_view_to_fillRead];

export const creativesPerms = [
    PermissionName.UniledportalCreativeRead,
    PermissionName.UniledportalCreative_groupRead,
    PermissionName.UniledportalFileRead,
];

export const reportsPerms = [PermissionName.ReportingPcareportRead];

export const costPerms = [
    PermissionName.UniledportalBudget_summaryRead,
    PermissionName.UniledportalBudget_summary_line_itemRead,
];

const CreateCreativesPerms: PermissionName[] = [PermissionName.UniledportalCreativeCreate];
export const UpdateDisplaysPermissions: PermissionName[] = UpdateCampaignLineItemsPagePermissions;
export const NewCampaignPermissions: PermissionName[] = NewCampaignPagePermissions;
export const CampaignUpdateDialogPermissions = [PermissionName.UniledportalCampaignUpdate];
export const BookingSummaryPermissions = [
    PermissionName.UniledportalCampaign_booking_summariesRead,
];
const SpecsDownloadPermissions = [PermissionName.UniledportalCampaignSpecsDownload];
const CreativeSpecsDownloadPermissions = [PermissionName.UniledportalCampaignCreativeDownload];
